/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { isFirstPage } from "selectors/pageNumber";
import { shouldStartRendering, getTotalPages } from "selectors/documentSelectors";
import { getIsInPlaceMode } from "selectors/viewModeSelectors";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import * as constants from "constants/constants";
import PreviousPageNavigationIconOld from "dc-icons/consumption/s_page_up_hud_18.svg";
import PreviousPageNavigationIconModern from "dc-icons/viewer2021/S_ChevronUpMedium_18_N.svg";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";

const mapStoreToProps = (stores, ownProps) => {
  const useModernViewer = getShouldUseModernViewer(stores);
  const shouldDisable = isFirstPage(stores) || !shouldStartRendering(stores) || getTotalPages(stores) === 0;
  const props = {
    ...ownProps,
    useModernViewer,
    icon: useModernViewer ? PreviousPageNavigationIconModern : PreviousPageNavigationIconOld,
    clickHandler: () => {
      if (getIsInPlaceMode(stores)) {
        stores.hudStore.setShouldUpdateHUDPosition(false);
      }
      stores.pagedViewState.goToPrevPage();
    },
    ariaLabel: useModernViewer ? "modernviewer.arialabel.pageUp" : "arialabel.pageUp",
    tooltipString: useModernViewer ? "modernviewer.tooltip.pageUp" : "tooltip.pageUp",
    tooltipDelay: constants.TOOLTIP_DELAY,
    shouldDisable,
    shouldDisableTooltip: shouldDisable
  };

  return props;
};

const PreviousPageNavigationContainer = inject(mapStoreToProps)(ButtonWrapper);

export { PreviousPageNavigationContainer };
